import "lazysizes";

import Swiper from "swiper/bundle";
import MicroModal from "micromodal";

import { modalShow, modalClose } from "./modules/_microModal";
import { setUpAccordion, details } from "./modules/_accordion.js";

import "swiper/css/bundle";
import "../scss/main.scss";

MicroModal.init({
  disableScroll: true,
  awaitCloseAnimation: true,
});

if (details) {
  setUpAccordion();
}

/**
 * menu
 */
const menu = document.querySelector(".js-menu");
if (menu) {
  const drawer = document.querySelector(".js-drawer");
  const body = document.querySelector("body");
  let isActive = null;

  const menuOpen = () => {
    menu.classList.add("is-open");
    drawer.classList.add("is-active");
    body.classList.add("is-fixed");
    const createBg = document.createElement("div");
    createBg.classList.add("js-drawer-bg");
    createBg.classList.add("p-drawer-bg");
    drawer.after(createBg);
    isActive = true;

    createBg.addEventListener("click", menuClose);

    const headerLinkElem = document?.querySelectorAll(
      ".l-header__logo a, .l-header__nav-link a"
    );
    if (headerLinkElem) {
      headerLinkElem.forEach((element) => {
        element.addEventListener("click", () => {
          if (isActive) {
            menuClose();
          }
        });
      });
    }
  };

  const menuClose = () => {
    menu.classList.remove("is-open");
    drawer.classList.remove("is-active");
    body.classList.remove("is-fixed");

    const overlay = document.querySelector(".js-drawer-bg");
    overlay.remove();
    isActive = false;
  };

  menu.addEventListener("click", (e) => {
    e.preventDefault();
    if (!isActive) {
      menuOpen();
    } else {
      menuClose();
    }
  });

  drawer.querySelectorAll(".p-drawer__item a").forEach((element) => {
    element.addEventListener("click", () => {
      menuClose();
    });
  });

  const mediaQuery = window.matchMedia("(max-width: 1023px)");
  mediaQuery.addEventListener("change", (e) => {
    e.preventDefault();
    if (isActive) {
      menuClose();
    }
  });
}

/**
 * リンク behavior smooth
 */
const smoothScrollElems = document.querySelectorAll('a[href^="#"]');

if (smoothScrollElems) {
  smoothScrollElems.forEach((element) => {
    element.addEventListener("click", (event) => {
      event.preventDefault();
      const href = element.getAttribute("href");

      let targetElement;
      if (href === "#") {
        targetElement = document.querySelector("html");
      } else {
        targetElement = document.getElementById(href.replace("#", ""));
      }

      const rect = targetElement.getBoundingClientRect().top;
      const offset = window.pageYOffset;
      const target = rect + offset;
      window.scrollTo({
        top: target,
        behavior: "smooth",
      });
    });
  });
}

/**
 * .is-active 切り替え
 */
const toggleElemes = document.querySelectorAll(".js-toggle");

if (toggleElemes) {
  function toggle() {
    const isToggleAll = this.classList.contains("-all");

    if (!isToggleAll) {
      this.classList.toggle("is-active");
    } else {
      document
        .querySelectorAll(".-all")
        .forEach((element) => element.classList.toggle("is-active"));
    }
  }

  toggleElemes.forEach((element) => {
    element.addEventListener("click", toggle);
  });
}

/**
 * link拡張
 */
const linkElemes = document.querySelectorAll(".js-link");

if (linkElemes) {
  linkElemes.forEach((element) => {
    function linkExtension(e) {
      e.preventDefault();
      const favoriteButton = this.querySelector(".js-favorite");
      const exclusion = this.querySelector(".js-link-exclusion");
      if (
        (favoriteButton && e.target === favoriteButton) ||
        (exclusion && e.target === exclusion)
      )
        return;
      const parent = this.closest(".js-link-extension");
      const url = parent.querySelector("a").href;
      const isTarget = parent.querySelector("a").hasAttribute("target");
      if (!isTarget) {
        location.href = url;
      } else {
        open(url, "_blank");
      }
    }

    element.addEventListener("click", linkExtension);
  });
}

/**
 * female/ スライダー
 */
const femaleSliderElem = document.querySelector(".js-female-slider");

if (femaleSliderElem) {
  const thumb = document.querySelectorAll(".js-female-thumb li");

  const switchThumb = (index) => {
    document
      .querySelector(".js-female-thumb .thumb-media-active")
      .classList.remove("thumb-media-active");
    thumb[index].classList.add("thumb-media-active");
  };

  /* eslint-disable */
  const femaleSlider = new Swiper(".js-female-slider", {
    effect: "fade",
    crossFade: true,
    autoplay: {
      delay: 10000,
      disableOnInteraction: false,
    },
    speed: 1000,
    on: {
      afterInit: (swiper) => {
        thumb[swiper.realIndex].classList.add("thumb-media-active");
        for (let i = 0; i < thumb.length; i++) {
          thumb[i].onclick = () => {
            swiper.slideTo(i);
          };
        }
      },
      slideChange: (swiper) => {
        switchThumb(swiper.realIndex);
      },
    },
  });
  /* eslint-enable */
}

/**
 * fade表示
 */
const fadeElems = document.querySelectorAll(".js-fade");

if (fadeElems) {
  const options = {
    root: null,
    rootMargin: "0px 0px",
    threshold: 0,
  };

  const observerFade = new IntersectionObserver(doWhenIntersect, options);

  fadeElems.forEach((elem) => {
    observerFade.observe(elem);
  });

  function doWhenIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        addActive(entry.target);
      }
    });
  }

  function addActive(element) {
    element.classList.add("is-active");
  }
}

/**
 * 逆オファー
 */
const counterOfferButtons = document.querySelectorAll(".js-counterOffer");
if (counterOfferButtons) {
  counterOfferButtons.forEach((button) => {
    button.addEventListener("click", () => {
      modalShow("modal-counterOffer");
    });
  });
}

/**
 *  my-profile 趣味や楽しみ編集
 */
const editButton = document.querySelector(".js-hobbys-edit");
if (editButton) {
  editButton.addEventListener("click", init);

  function init(e) {
    e.preventDefault();
    const currentHobbys = document.querySelector(".js-myprofile-hobbys");
    const currentArray = createValueArray(currentHobbys);

    modalShow("modal-editHobby");

    setNewHobbys(currentArray);
  }

  const setNewHobbys = (currentArray) => {
    const isEditing = true;
    const newHobbys = document.querySelector(".js-new-hobbys");
    newHobbys.innerHTML = "";

    currentArray.forEach((hobby) => {
      const elem = createElem(hobby, isEditing);
      newHobbys.appendChild(elem);
    });

    const add = document.querySelector(".js-add");
    const inputArea = add.querySelector('input[type="text"]');
    const addButton = add.querySelector("button");
    inputArea.value = "";

    addButton.addEventListener("click", addNewHobbys);

    function addNewHobbys(e) {
      e.preventDefault();
      if (inputArea.value === "") return;

      const newHobbyArray = createValueArray(newHobbys);

      if (newHobbyArray.indexOf(inputArea.value) === -1) {
        const inputValue = inputArea.value;
        const elem = createElem(inputValue, isEditing);
        newHobbys.appendChild(elem);
      }
      inputArea.value = "";
      deleteHobby(newHobbys);
    }

    deleteHobby(newHobbys);

    const decisionButton = document.querySelector(".js-decision");
    decisionButton.addEventListener("click", (e) => {
      e.preventDefault();

      const newArray = createValueArray(newHobbys);
      registerHobbys(newArray, isEditing);
      modalClose("modal-editHobby");
      addButton.removeEventListener("click", addNewHobbys);
    });
  };

  const deleteHobby = (newHobbys) => {
    const deleteHobbyButtons = newHobbys.querySelectorAll(".js-hobby-delete");
    deleteHobbyButtons.forEach((button) => {
      button.addEventListener("click", function (e) {
        e.preventDefault();
        this.parentNode.remove();
      });
    });
  };

  const registerHobbys = (newArray, isEditing) => {
    isEditing = false;
    const currentHobbys = document.querySelector(".js-myprofile-hobbys");
    currentHobbys.innerHTML = "";
    if (newArray.length !== 0) {
      newArray.forEach((hobby) => {
        const elem = createElem(hobby, isEditing);
        currentHobbys.appendChild(elem);
      });
    } else {
      const elem = document.createElement("div");
      elem.innerHTML = "未登録";
      currentHobbys.appendChild(elem);
    }
  };

  // 現在登録されている趣味を取得
  const createValueArray = (hobbys) => {
    const currentArray = [...hobbys.querySelectorAll("li")].map(
      (item) => item.textContent
    );
    return currentArray;
  };

  const createElem = (hobby, isEditing) => {
    const liElem = document.createElement("li");
    liElem.classList.add("c-hobby-list__item");
    const html = isEditing
      ? `${hobby}<button class="js-hobby-delete"></button>`
      : hobby;
    liElem.innerHTML = html;
    return liElem;
  };
}

/**
 * my-profile メディア編集
 */
const profileFilesLists = document.querySelectorAll(".js-file-editing");

if (profileFilesLists) {
  profileFilesLists.forEach((list) => {
    list.querySelectorAll("li").forEach((item) => {
      const input = item.querySelector(".c-file input");
      const img = item.querySelector("img");
      const editButton = item.querySelector(".js-file-edit");

      const RUNNING_VALUE = "running";
      const IS_ACTIVE = "is-active";
      const animTiming = {
        duration: 500,
        easing: "ease-out",
      };

      input.addEventListener("change", handleChange);

      editButton.addEventListener("click", handleClick);

      function handleChange(e) {
        e.preventDefault();
        if (e.target.getAttribute("accept") === "video/*") {
          changeThumb(e);
        } else {
          changeThumbImage(e);
        }
      }

      function handleClick(e) {
        e.preventDefault();

        if (this.dataset.animStatus === RUNNING_VALUE) return;

        if (!this.classList.contains("is-active")) {
          editClose(e);
          this.classList.add(IS_ACTIVE);
          this.dataset.animStatus = RUNNING_VALUE;
          setTimeout(() => {
            this.dataset.animStatus = "";
          }, animTiming.duration);

          const editElem = createEditElem(this);
          this.appendChild(editElem);

          const deleteButton = this.querySelector("button");
          function deleteThumb(e) {
            e.preventDefault();

            img.removeAttribute("src");
            img.parentNode.dataset.display = "false";
            input.value = "";
          }
          deleteButton.addEventListener("click", deleteThumb);

          const changeButton = this.querySelector("label");
          changeButton.addEventListener("click", function (e) {
            e.stopPropagation();
          });

          changeButton.addEventListener("change", function (e) {
            if (e.target.getAttribute("accept") === "video/*") {
              changeThumb(e);
            } else {
              changeThumbImage(e);
            }

            editClose(e);
          });
        }
      }

      document.addEventListener("click", function (e) {
        if (editButton.dataset.animStatus === RUNNING_VALUE) return;

        if (editButton.classList.contains("is-active")) {
          editClose();
        }
      });

      const sizeCheck = (e, size) => {
        const sizeLimit = 1024 * 1024 * size;
        const file = e.target.files[0];
        if (file.size > sizeLimit) {
          alert(`ファイルサイズは${size}MB以下にしてください`);
          return false;
        } else {
          return file;
        }
      };

      function changeThumb(e) {
        const file = sizeCheck(e, 50);
        if (file) {
          const fileReader = new FileReader();
          fileReader.onload = function () {
            const blob = new Blob([fileReader.result], { type: file.type });
            const url = URL.createObjectURL(blob);
            const video = document.createElement("video");
            const timeupdate = function () {
              if (snapImage()) {
                video.removeEventListener("timeupdate", timeupdate);
                video.pause();
              }
            };
            video.addEventListener("loadeddata", function () {
              if (snapImage()) {
                video.removeEventListener("timeupdate", timeupdate);
              }
            });
            const snapImage = function () {
              const canvas = document.createElement("canvas");
              canvas.width = video.videoWidth;
              canvas.height = video.videoHeight;
              canvas
                .getContext("2d")
                .drawImage(video, 0, 0, canvas.width, canvas.height);
              const image = canvas.toDataURL();
              const success = image.length > 1000;
              if (success) {
                img.src = image;
                item
                  .querySelector(".p-profile-movie__thumb")
                  .insertBefore(img, editButton);
                img.parentNode.dataset.display = "true";
                URL.revokeObjectURL(url);
              }
              return success;
            };
            video.addEventListener("timeupdate", timeupdate);
            video.preload = "metadata";
            video.src = url;
            // Load video in Safari / IE11
            video.muted = true;
            video.playsInline = true;
            video.play();
          };
          fileReader.readAsArrayBuffer(file);
        }
      }

      function changeThumbImage(e) {
        const file = sizeCheck(e, 1);
        if (file) {
          const fileReader = new FileReader();
          fileReader.onload = function (e) {
            const url = e.target.result;
            img.src = url;
            img.parentNode.dataset.display = "true";
          };
          fileReader.readAsDataURL(file);
        }
      }

      const createEditElem = (button) => {
        const mediaType = button.classList.contains("p-profile-img__button")
          ? "写真"
          : "動画";

        const accept =
          mediaType === "写真" ? "image/png,image/jpeg" : "video/*";

        const elem = document.createElement("div");
        elem.classList.add("c-file-edit__body");
        elem.classList.add("js-edit");
        const html = `
					<label><input type="file" name="" accept=${accept}>${mediaType}を変更</label>
					<button type="button" name="">${mediaType}を削除</button>`;
        elem.innerHTML = html;

        return elem;
      };

      function editClose(e) {
        const activeButton = [...list.querySelectorAll(".js-file-edit")].find(
          (button) => button.classList.contains("is-active")
        );

        if (activeButton && activeButton.dataset.animStatus === RUNNING_VALUE)
          return;

        if (activeButton) {
          const editElem = activeButton.querySelector(".js-edit");

          const closingAnimKeyframes = [
            {
              opacity: 1,
              translate: "-50% 0",
            },
            {
              opacity: 0,
              translate: "-50% -10px",
            },
          ];

          const animationPromise = () => {
            return new Promise((resolve) => {
              activeButton.classList.remove(IS_ACTIVE);
              editElem.animate(closingAnimKeyframes, animTiming);

              setTimeout(() => {
                resolve();
              }, animTiming.duration);
            });
          };

          animationPromise().then(() => {
            activeButton.removeChild(editElem);
          });
        }
      }
    });
  });
}

/**
 * my-profile/ preview
 */
const previewButtons = document.querySelectorAll(".js-preview-button");
if (previewButtons) {
  previewButtons.forEach((button) => {
    button.addEventListener("click", function (e) {
      e.preventDefault();
      modalShow("modal-preview");

      /**
       * myprofile/ preview videoスライダー
       */
      const femaleVideoElem = document.querySelector(".js-female-video-slider");

      if (femaleVideoElem) {
        const breakpoints = [
          {
            breakpoint: 0,
            slidesPerView: 1,
          },
          {
            breakpoint: 1024,
            slidesPerView: 2,
          },
        ];
        breakpoints.reverse();

        let item = null;
        let perview;
        let isInited = false;

        const slideLength =
          femaleVideoElem.querySelectorAll(".swiper-slide").length;

        const femaleVideoSlider = () => {
          for (const key in breakpoints) {
            const bp = breakpoints[key].breakpoint;

            if (window.matchMedia("(min-width:" + bp + "px)").matches) {
              perview = breakpoints[key].slidesPerView;
              break;
            }
          }

          if (slideLength > perview) {
            if (isInited) return;
            initSwiper();
            isInited = true;
          } else if (item) {
            item.destroy(false, true);
            isInited = false;
          }
        };

        const initSwiper = () => {
          item = new Swiper(femaleVideoElem, {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 10,
            speed: 1000,
            autoplay: {
              delay: 10000,
              disableOnInteraction: false,
            },
            grabCursor: true,
            watchSlidesProgress: true,
            pagination: {
              el: ".js-female-video-slider .swiper-pagination",
              clickable: true,
            },
            breakpoints: {
              1024: {
                slidesPerView: 2,
                slidesPerGroup: 2,
              },
            },
          });
        };

        let time = 0;
        window.addEventListener("resize", () => {
          clearTimeout(time);
          time = setTimeout(() => {
            femaleVideoSlider();
          }, 500);
        });
        femaleVideoSlider();
      }

      /**
       * myprofile/ preview freeModeスライダー
       */
      const freeSliders = document.querySelectorAll(".js-slider-free");

      if (freeSliders) {
        const options = {
          slidesPerView: "auto",
          spaceBetween: 10,
          freeMode: true,
        };
        freeSliders.forEach((slider) => {
          /* eslint-disable */
          const swiper = new Swiper(slider, options);
          /* eslint-enable */
        });
      }
    });
  });
}

/**
 * contact/ textarea高さ調整
 */
const messageInput = document.querySelector(".js-messageInput");
if (messageInput) {
  const adjustTextareaHeight = () => {
    const input = document.querySelector(".js-messageInput");
    input.style.height = "auto";
    input.style.height = `${input.scrollHeight}px`;
  };

  const messageArea = document.querySelector(".js-messageArea");
  messageArea.scrollTo(0, messageArea.scrollHeight);

  messageInput.addEventListener("input", adjustTextareaHeight);

  adjustTextareaHeight();
}

/**
 * パスワード表示切替
 */
const viewPasswordElem = document.querySelectorAll(".js-password-view");
if (viewPasswordElem) {
  const target = document.querySelectorAll(".js-password-toggle");
  viewPasswordElem.forEach((element, index) => {
    element.addEventListener("change", () => {
      target[index].type === "password"
        ? (target[index].type = "text")
        : (target[index].type = "password");
    });
  });
}

/**
 * 休会・退会の選択
 */
const requestRadioButtons = document.querySelectorAll(".js-login-requestRadio");
if (requestRadioButtons) {
  requestRadioButtons.forEach((radio) => {
    radio.addEventListener("change", updateOptions);
  });

  const optionTemporaryAbsence = [
    {
      value: "",
      text: "---",
    },
    {
      value: "option1",
      text: "休会理由1",
    },
    {
      value: "option2",
      text: "休会理由2",
    },
  ];

  const optionUnsubscribe = [
    {
      value: "",
      text: "---",
    },
    {
      value: "option1",
      text: "退会理由1",
    },
  ];

  function updateOptions() {
    const requestSelect = document.querySelector(".js-login-requestSelect");
    if (!requestSelect) return;
    requestSelect.innerHTML = "";

    const checkedRadio = document?.querySelector(
      'input[name="requestRadio"]:checked'
    );

    const checkedRadioValue = checkedRadio ? checkedRadio.value : null;

    let optionsToAdd = [];

    if (checkedRadioValue === "temporaryAbsence") {
      optionsToAdd = optionTemporaryAbsence;
    } else if (checkedRadioValue === "unsubscribe") {
      optionsToAdd = optionUnsubscribe;
    }

    optionsToAdd.forEach((option) => {
      const dom = document.createElement("option");
      dom.value = option.value;
      dom.text = option.text;
      requestSelect.appendChild(dom);
    });
  }

  updateOptions();
}

/**
 * 仮会員 追加書類のアップロード
 */
const loginFileButtons = document.querySelectorAll(".js-login-file");

if (loginFileButtons) {
  loginFileButtons.forEach((loginFileButton) => {
    loginFileButton.addEventListener("click", (e) => (e.target.value = ""));
    loginFileButton.addEventListener("change", (e) => {
      e.preventDefault();
      const file = e.target.files[0];

      const sizeLimit = 1024 * 1024 * 1;
      if (file.size > sizeLimit) {
        alert("ファイルサイズは1MB以下にしてください");
        return;
      }

      const parent = e.target.closest(".js-login-fileItem");
      const imgElem = parent.querySelector(".js-login-fileImg");
      const fileName = parent.querySelector(".js-login-fileName");
      const deleteElem = parent.querySelector(".js-login-fileDelete");

      if (file) {
        imgElem
          .querySelector("img")
          .setAttribute("src", URL.createObjectURL(file));
        imgElem.style.display = "block";
        fileName.textContent = file.name;
        deleteElem.style.display = "block";
      }

      deleteElem.addEventListener("click", (e) => {
        e.preventDefault();
        imgElem.querySelector("img").setAttribute("src", "");
        imgElem.style.display = "none";
        fileName.textContent = "ファイルが選択されていません。";
        deleteElem.style.display = "none";
      });
    });
  });
}
